import { render } from "./list.vue?vue&type=template&id=519525f6&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=519525f6&lang=scss&scoped=true"

import exportComponent from "D:\\Desktop\\soccerbettinganalysis\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519525f6"]])

export default __exports__